import Router from '@/router'
import Message from './message'
import store from '../stores'
import Vue from '../main.js'

export const handleError = (error, response) => {
  if (error.code === 3000) {
    console.log(response)
    // Message.warning('请先登录以后，再尝试该操作！')
    if (response.config.url.includes('statementAccount/saveOrUpdate')) {
      if (error.message) {
        Message.error(error.message)
      }
    } else {
      store.commit('SET_USER_INFO', {})
      Vue.$root.eventHub.$emit('get-login')
    }
    // Router.replace('/image-search')
  } else if (error.code === 1001) {
    Message.warning('登录口令已失效, 请重新登录')
    Router.replace('/image-search')
    Vue.$root.eventHub.$emit('get-login')
    store.commit('SET_USER_INFO', {})
  } else {
    if (error.message) {
      Message.error(error.message)
    }
  }
  // if (error.code === 3003) {
  // } else if (error.code === 3002) {
  //   let messageText = ''
  //   if (Array.isArray(error.data) && error.data.length) {
  //     error.data.forEach((item, index) => {
  //       messageText += item.cause
  //       if (index < error.data.length - 1) {
  //         messageText += '，'
  //       }
  //     })
  //   }
  //   Message.error(messageText)
  // } else if (error.code === 5013 || error.code === 5011 || error.code === 5009) {
  //   Message.error('登录已过期，请重新登录')
  //   // goLogin()
  // } else {
  //   if (error.message && error.message.indexOf('401') === -1) {
  //     Message.error(error.message || '系统异常，请稍后再试！')
  //   } else {
  //     Message.error('登录口令已失效，请重新登录！')
  //     // goLogin()
  //   }
  // }
}
